import { http } from '@/api/client/httpClient';
import type {
  NotificationDto,
  NotificationInputDto,
  PaginatedNotifications,
} from '@/api/types/notifications';

// ABP conventional-controller mapping of Finkit.Notifications.NotificationAppService
// (concrete namespace => /api/app/notification). Only the Get prefix is stripped;
// a method param named exactly `id` becomes a route-path segment; a non-Get method
// with a DTO is POST:
//   GetMessagesAsync(input)      -> GET    /api/app/notification/messages
//   GetMyUnreadCountAsync()      -> GET    /api/app/notification/my-unread-count
//   MarkReadAsync(id)            -> POST   /api/app/notification/{id}/mark-read
//   MarkAllAsReadAsync()         -> POST   /api/app/notification/mark-all-as-read
//   DeleteAsync(id)              -> DELETE /api/app/notification/{id}
// (These exactly match the legacy bell's notifications-client.js API map.)
const BASE = '/api/app/notification';

export const notificationsApi = {
  async getMessages(input: NotificationInputDto): Promise<PaginatedNotifications> {
    const { data } = await http.get<PaginatedNotifications>(`${BASE}/messages`, { params: input });
    return data;
  },

  async getMyUnreadCount(): Promise<number> {
    const { data } = await http.get<number>(`${BASE}/my-unread-count`);
    return data;
  },

  async markRead(id: string): Promise<void> {
    await http.post(`${BASE}/${encodeURIComponent(id)}/mark-read`);
  },

  async markAllAsRead(): Promise<void> {
    await http.post(`${BASE}/mark-all-as-read`);
  },

  async remove(id: string): Promise<void> {
    await http.delete(`${BASE}/${encodeURIComponent(id)}`);
  },
};

export type { NotificationDto };
